// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgTextTypeCodeblock24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<g id="Icon/Communication/Text_Type_Codeblock_24">
					<path
						id="Union"
						fillRule="evenodd"
						clipRule="evenodd"
						d="M10.5395 5.26949L10.1188 5.1541C9.97269 5.10866 9.82486 5.12879 9.69736 5.20086C9.56784 5.27407 9.47844 5.3891 9.43586 5.52751L9.43034 5.54544L8.34056 12.8189C8.30383 12.9567 8.31976 13.1001 8.39246 13.2287C8.46567 13.3582 8.58066 13.4477 8.71907 13.4903L9.13974 13.6057C9.28584 13.6511 9.43367 13.631 9.56118 13.5589C9.6907 13.4857 9.7801 13.3707 9.82269 13.2323L9.8282 13.2144L10.918 5.94095C10.9547 5.80309 10.9388 5.65974 10.8661 5.53111C10.7929 5.40159 10.6779 5.31208 10.5395 5.26949ZM6.82843 5.68135C6.67175 5.68135 6.53615 5.74573 6.43395 5.84794L3.29647 8.98541C3.19426 9.08762 3.12988 9.22322 3.12988 9.3799C3.12988 9.53658 3.19426 9.67218 3.29647 9.77438L6.43395 12.9119C6.53615 13.0141 6.67175 13.0784 6.82843 13.0784C6.98511 13.0784 7.12071 13.0141 7.22292 12.9119L7.55956 12.5752C7.66176 12.473 7.72614 12.3374 7.72614 12.1807C7.72614 12.0241 7.66176 11.8885 7.55956 11.7863L5.1532 9.3799L7.55956 6.97354C7.66176 6.87134 7.72614 6.73574 7.72614 6.57906C7.72614 6.42238 7.66176 6.28678 7.55956 6.18457L7.22292 5.84794C7.12071 5.74573 6.98511 5.68135 6.82843 5.68135ZM12.4301 5.68135C12.2734 5.68135 12.1378 5.74573 12.0356 5.84794L11.699 6.18458C11.5968 6.28678 11.5324 6.42238 11.5324 6.57906C11.5324 6.73574 11.5968 6.87134 11.699 6.97354L14.1053 9.3799L11.699 11.7863C11.5968 11.8885 11.5324 12.0241 11.5324 12.1807C11.5324 12.3374 11.5968 12.473 11.699 12.5752L12.0356 12.9119C12.1378 13.0141 12.2734 13.0784 12.4301 13.0784C12.5868 13.0784 12.7224 13.0141 12.8246 12.9119L15.9621 9.77438C16.0643 9.67218 16.1287 9.53658 16.1287 9.3799C16.1287 9.22322 16.0643 9.08762 15.9621 8.98541L12.8246 5.84794C12.7224 5.74573 12.5868 5.68135 12.4301 5.68135ZM16.5049 5.50488V7.00488H17.5049C17.781 7.00488 18.0049 7.22874 18.0049 7.50488V18.5049C18.0049 18.781 17.781 19.0049 17.5049 19.0049H6.50488C6.22874 19.0049 6.00488 18.781 6.00488 18.5049V15.5049H4.50488V18.5049C4.50488 19.6095 5.40031 20.5049 6.50488 20.5049H17.5049C18.6095 20.5049 19.5049 19.6095 19.5049 18.5049V7.50488C19.5049 6.40031 18.6095 5.50488 17.5049 5.50488H16.5049Z"
					/>
				</g>
			</Svg>
		);
	}
);
SvgTextTypeCodeblock24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgTextTypeCodeblock24;
